import { store } from "./store";
import { generateSearchParams } from "./utm";

export const getRegisterUrl = (locale, params = {}) => {
  const COUNTRY = store.selectedPartner?.AppCountry?.country_code;
  const SEARCH = generateSearchParams(
    COUNTRY ? { ...params, country: COUNTRY } : params
  );

  return `https://rep.guide/${locale}/register${SEARCH}`;
};
